import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { rejectDepositRequest } from '../depositRequestsEndpoints'
import { depositRequestKeys } from '../depositRequestsQueryKeys'
import type { RejectDepositRequestInput } from '../../types/depositRequestsTypes'

export function useRejectDepositRequestMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: RejectDepositRequestInput) => rejectDepositRequest(input),
    onSuccess: (_, vars) => {
      qc.invalidateQueries({ queryKey: depositRequestKeys.lists() })
      qc.invalidateQueries({ queryKey: depositRequestKeys.statusCounts() })
      qc.invalidateQueries({ queryKey: depositRequestKeys.detail(vars.id) })
    },
  })
}
